"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackB2BInCheckout = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
function trackB2BInCheckout(clickText, url) {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: enums_1.EventAction.TextClick,
        eventLabel: 'Link to B2B shop',
        eventData: {
            eventName: enums_1.GA4EventName.ClickTextLink,
            feature_category: enums_1.GA4FeatureCategory.Cart,
            click_element: enums_1.ClickElement.B2BLink,
            click_text: clickText,
            click_url: url,
        },
    });
}
exports.trackB2BInCheckout = trackB2BInCheckout;
//# sourceMappingURL=trackB2BInCheckout.js.map